var minPriceMapSearch = Vue.component('min-price-map-search', {
    props: {
    },
    data: function () {
        return{
            message: {
                selectAirport: FmtMessage.getMessage('js.flight.select.airport') ? FmtMessage.getMessage('js.flight.select.airport') : 'js.flight.select.airport',
                search: FmtMessage.getMessage("js.label.search") ? FmtMessage.getMessage("js.label.search") : 'js.label.search',
                notFound: FmtMessage.getMessage("js.not.found") ? FmtMessage.getMessage("js.not.found") : 'js.not.found',
                noticeText:	FmtMessage.getMessage("js.flight.map.notice") ? FmtMessage.getMessage("js.flight.map.notice") : 'js.flight.map.notice',	
            },
            selectedAirport: null,
            airports: [],
            search: {
                departureAirport: null,
                fromDate: null,
                toDate: null,
            },
            selectedMonth: null,
            fromAirport: null,
            currency: '',
            searchResult: {
                minPrices: []
            },
            filterResult: [],
            error: false,
            notFound: false,
            searchText: ''
        }
    },
    created: function () {
    },
    computed: {
        hasData: function () {
            return this.searchResult.minPrices.length > 1;
        }
    },
    methods: {
        createWarning: function(){
            $( ".warningDialog" ).dialog({
                resizable: false,
                height:240,
                width:400,
                modal: true,
                buttons:
                    [
                        {
                            text: FmtMessage.getMessage('js.search.no.result'),
                            click: function() {
                                $( this ).dialog( "close" );
                            }
                        }
                    ]
            }).show();
        },
        getFromCookie: function(){
            var itemJson = $.cookie('minPriceFromAirport', { path : '/' });
            if(itemJson) {
                var item = JSON.parse(itemJson);
                this.search.departureAirport = item.code;
                this.searchText = item.value;
                this.getPrices();
            }
        },

        getPrices: function () {
            var vm = this;
            vm.search.fromDate = $.datepicker.formatDate("dd.mm.yy", vm.selectedMonth.first);
            vm.search.toDate = $.datepicker.formatDate("dd.mm.yy", vm.selectedMonth.last);

            if (isNullOrEmpty(vm.search.departureAirport)){
                this.error = true;
                return;
            }
            this.$parent.setPriceLoading(true);

            $.ajax({
                url : "/getSearchMapMinPrice",
                dataType : "json",
                data : vm.search
            }).then(function(response) {
                if (response.success) {

                    if (response.minPrices.length == 0){
                        vm.notFound = true;
                        vm.createWarning();
                        // return;
                    }

                    vm.minPrices = response.minPrices;
                    vm.fromAirport = response.fromAirportInfo;
                    vm.searchResult = {
                        minPrices: response.minPrices,
                        fromAirport: response.fromAirportInfo,
                        currency: '',
                        search: vm.search
                    };

                    if (response.minPrices.length > 0){
                        vm.searchResult.currency = response.minPrices[0].currency;
                        vm.currency = response.minPrices[0].currency;
                    }

                    vm.$emit('input', vm.searchResult);
                }
                else {
                    vm.searchResult = {
                        minPrices: [],
                        fromAirport: [],
                        currency: ''
                    };
                    vm.$emit('input', vm.searchResult);
                    vm.createWarning();
                }

            }).fail(function(error) {
            }).done(function () {
                vm.$parent.setPriceLoading(false);
            });

        },
    },
    watch:{
        filterResult: {
            deep: true,
            handler: function(){
                this.$emit('filter-result', this.filterResult)
            }
        }
    },
    template: '<div class="row min-price-search">\
                    <div class="col-md-4 col-sm-7 col-xs-12">\
                        <airport-autocomplete v-model="search.departureAirport" :text="searchText" :placeholder="message.selectAirport" :error="error"/>\
    	            </div>\
                    <div class="col-md-2 col-sm-3 col-xs-8">\
                        <monthly-date-range-select v-model="selectedMonth"/>\
                    </div>\
    	 			<div class="col-md-2 col-sm-2 col-xs-4 search-btn">\
        			<button @click="getPrices" class="btn btn-primary btn-block" style="max-width:120px">{{message.search}}</button>\
    				</div>\
    	            <div class="col-md-4 col-xs-12"><span class="notice pull-right">{{message.noticeText}}</span>\</div>\
                    <div class="col-md-12 col-sm-12 hidden-xs" :class="{\'hidden\': !hasData}">\
                        <price-map-filter v-model="filterResult" :data="searchResult.minPrices" :currency="currency"/>\
                    </div>\
                </div>'
});
